
"use client";

import {
  LogLevel,
  StatsigProvider as SDKProvider,
  useClientBootstrapInit,
} from "@statsig/react-bindings";

function StatsigProvider({
  values,
  user,
  children,
}: {
  values: string;
  user: object;
  children: React.ReactNode;
}) {
  const client = useClientBootstrapInit(
    process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY!,
    user,
    values,
    {
      // Remove in prod
      logLevel: process.env.NODE_ENV === "production" ? LogLevel.Info : LogLevel.Debug,
    }
  );

  return <SDKProvider client={client}>{children}</SDKProvider>;
}

export { StatsigProvider };